<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
import systemService from '@/services/system-service.js';
import LoginService from '@/services/login.service';
import themeService from '@/services/theme.service.js';
import { CHANGE_THEME } from './store/mutation-types';
import { IsMobile } from './utils/utils';
import http from './plugins/http';

export default {
    name: 'app',
    created() {
        window.addEventListener('touchend', () => {}, {
            passive: true,
        });

        if (IsMobile()) {
            http.loadAppJson().then(() => {
                if (
                    this.$mobileURL !== 'http://mobileurl' &&
                    this.$mobileURL !== 'https://mobileurl'
                ) {
                    window.location.href = this.$mobileURL;
                }
            });
            return;
        }

        themeService.getSysTheme().then(res => {
            if (res.Success) {
                this.$store.commit(CHANGE_THEME, res.Result);
            }
        });

        if (this.isIE() && this.iEVersion() < 11) {
            this.showAlertDialog();
        }
    },

    mounted() {
        this.setSystemTitle();
    },
    methods: {
        setSystemTitle() {
            systemService.getEntBaseInfo().then(res => {
                document.title = res.SystemName;
                LoginService.SystemName = res.SystemName;
            });
        },
        isIE() {
            return !!window.ActiveXObject || 'ActiveXObject' in window;
        },
        iEVersion() {
            // 取得浏览器的userAgent字符串
            const userAgent = navigator.userAgent;
            // 判断是否为小于IE11的浏览器
            const isLessIE11 =
                userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1;
            // 判断是否为IE的Edge浏览器
            const isEdge = userAgent.indexOf('Edge') > -1 && !isLessIE11;
            // 判断是否为IE11浏览器
            const isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1;
            if (isLessIE11) {
                const IEReg = new RegExp('MSIE (\\d+\\.\\d+);');
                // 正则表达式匹配浏览器的userAgent字符串中MSIE后的数字部分，，这一步不可省略！！！
                IEReg.test(userAgent);
                // 取正则表达式中第一个小括号里匹配到的值
                const IEVersionNum = parseFloat(RegExp['$1']);
                if (IEVersionNum === 7) {
                    // IE7
                    return 7;
                } else if (IEVersionNum === 8) {
                    // IE8
                    return 8;
                } else if (IEVersionNum === 9) {
                    // IE9
                    return 9;
                } else if (IEVersionNum === 10) {
                    // IE10
                    return 10;
                } else {
                    // IE版本<7
                    return 6;
                }
            } else if (isEdge) {
                // edge
                return 99;
            } else if (isIE11) {
                // IE11
                return 11;
            } else {
                // 不是ie浏览器
                return -1;
            }
        },
        
        showAlertDialog() {
            this.$alert('您好！浏览器版本低于系统要求，请联系信息部升级IE！', '提示', {
                confirmButtonText: '确定',
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showClose: false,
                showConfirmButton: false,
            }).then(() => {
                this.showAlertDialog();
            });
        },
    },
};
</script>

<style scoped>
#app {
    height: 100%;
    background-color: white;
}

</style>
